import React from 'react';
import SubmissionListGrid from './SubmissionListGrid';

/**
 * The Submissions list (/submission). Its workflow submenus (Awaiting
 * Documents, Unresponsive) render the same grid from ReportPage with their own
 * report (REG-828).
 */
export default function SubmissionPage(): React.ReactElement {
  return <SubmissionListGrid />;
}
